<template>
  <component :is="tag" :class="['btn', `btn--${customClass}`]" :to="to" :href="tag === 'a' ? to : ''" :target="target" >
    {{ text }}
  </component>
</template>

<script>
export default {
  name: 'BaseBtn',
  props: {
    text: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    },
    to: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: ''
    }
  },
  computed: {
    tag() {
      return this.to ? this.to.includes('http://') || this.to.includes('https://') ? 'a' : 'nuxt-link' : 'button'
    }
  }
}
</script>

<style lang="scss">
.no-touch {
  .btn {
    &--default-text {
      &:hover {
        border-width: 2px;
      }
    }
  }
}

.btn {
  $parent: &;
  @include button-reset;

  font-family: $ToyotaBook;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  text-decoration: none;

  &--mb-30 {
    margin-bottom: 30px;
  }

  &--default {
    @include button-reset;
    @include easeOut;

    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 46px;
    padding: 0 30px;
    min-width: 180px;
    color: rgb(255, 255, 255);
    font-family: $ToyotaBook;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    border-radius: 24px;
    background-color: #ff0022;
    box-sizing: border-box;

    &:not(#{$parent}--disabled):hover {
      background-color: #d90022;
    }
  }

  &--disabled {
    cursor: not-allowed !important;
    opacity: 0.4;
  }

  &--hidded {
    display: none;
  }

  &--default-text {
    @include button-reset;
    @include easeOut;

    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 46px;
    padding: 0 30px;
    min-width: 180px;
    font-family: $ToyotaBook;
    font-size: 12px;
    color: #ff0022;
    border: 1px solid #ff0022;
    border-radius: 24px;
    box-sizing: border-box;
  }

  &--login {
    position: relative;
    width: 35px;
    height: 34px;
    font-size: 0 !important;
    background: url('~/static/img/spot-bg.svg') no-repeat center;
    background-size: contain;

    &::before {
      @include absolute-center;

      content: '';
      width: 15px;
      height: 16px;
      background: url('~/static/img/login-square-arrow-button-outline@3x.png')
        no-repeat center;
      background-size: contain;
    }
  }

  &--cabinet {
    position: relative;
    width: 36px;
    height: 36px;
    font-size: 0;
    background: url('~/static/img/gear-icon.svg') no-repeat center;
    background-size: contain;
    transition: all 600ms cubic-bezier(0.68, -0.55, 0.265, 1.55);

    &:hover {
      transform: rotate(360deg);
    }
  }

  &--facebook,
  &--linked-in,
  &--instagram,
  &--youtube {
    position: relative;
    display: block;
    transition: all 600ms cubic-bezier(0.68, -0.55, 0.265, 1.55);

    &::before {
      @include absolute-center;

      content: '';
    }

    &:hover {
      transform: translateY(-13px);
    }
  }

  &--facebook {
    width: 35px;
    height: 36.8px;
    background: url('~/static/img/facebook-shape@mb.svg') no-repeat center;
    background-size: cover;

    &::before {
      width: 6px;
      height: 13px;
      background: url('~/static/img/icon-facebook.svg') no-repeat center;
      background-size: cover;
    }
  }

  &--linkedin {
    width: 35px;
    height: 32px;
    background: url('~/static/img/linkedin-shape@mb.svg') no-repeat center;
    background-size: cover;

    &::before {
      width: 15px;
      height: 14px;
      background: url('~/static/img/icon-linkedin.svg') no-repeat center;
      background-size: cover;
    }
  }

  &--instagram {
    width: 36px;
    height: 35px;
    background: url('~/static/img/instagram-shape@mb.svg') no-repeat center;
    background-size: cover;

    &::before {
      width: 15px;
      height: 15px;
      background: url('~/static/img/icon-instagram.svg') no-repeat center;
      background-size: cover;
    }
  }

  &--youtube {
    width: 35px;
    height: 28px;
    background: url('~/static/img/youtube-shape@mb.svg') no-repeat center;
    background-size: cover;

    &::before {
      width: 16.8px;
      height: 12px;
      background: url('~/static/img/icon-youtube.svg') no-repeat center;
      background-size: cover;
    }
  }
}

@include media-min($tablet-width) {
  .btn {
    &--login {
      width: 44px;
      height: 42px;
    }

    &--mb-30 {
      margin-bottom: 30px;
    }

    &--default {
      min-width: 158px;
      max-width: initial;
      margin: 0 auto;
      padding: 0 20px;
    }
  }
}

@include media-min($desktop-width) {
  .btn {
    font-size: 15px !important;

    &--login {
      @include easeOut;

      display: flex;
      justify-content: center;
      align-items: center;
      width: 174px;
      height: 46px;
      border-radius: 24px;
      background: #ff0022;

      &::before {
        display: none;
      }

      &:hover {
        background-color: #d90022;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseBtn.vue